import(/* webpackMode: "eager", webpackExports: ["SharedProviders"] */ "/app/app/[locale]/providers/SharedProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
